var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RouterLink',{staticClass:"rewards-tournament",attrs:{"to":`/tournament/${_vm.tournamentId}`}},[_c('h3',{staticClass:"rewards-tournament__title"},[_vm._v(" "+_vm._s(_vm.tournamentName)+" ")]),_c('game-tag',{attrs:{"id":_vm.gameId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }